/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/ScoringOption',{
    Standard: 0,
    Lasvegas: 1,
    LasvegasCumulative: 2
});
